/** Paths do Hub SPA sem BrowserRouter basename (URLs absolutas /hub/…). */

/** Login canônico (SPA EleitorWEB) — fora do prefixo /hub. */
export const LOGIN_PATH = '/login'

export function stripHubPath(pathname: string): string {
  if (pathname === '/hub' || pathname === '/hub/') return '/'
  if (pathname.startsWith('/hub/')) return pathname.slice(4)
  return pathname
}

/** Ex.: hubPath('/inicio') → '/hub/inicio' */
export function hubPath(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  if (p === '/' || p === '') return '/hub/inicio'
  return `/hub${p}`
}
